<template>
  <div class="statistical-work">
    <mk-tabs-biz
      v-model="activeName"
      class="el-tabs-mk-ui"
    >
      <mk-tab-pane
        label="工作完成情况"
        name="workComplete"
      >
      </mk-tab-pane>
      <mk-tab-pane
        label="日志记录"
        name="logRecord"
      >
      </mk-tab-pane>
    </mk-tabs-biz>
    <work-complete v-if="activeName === 'workComplete'"></work-complete>
    <log-record v-if="activeName === 'logRecord'"></log-record>
  </div>
</template>
<script>
import workComplete from './work-complete/index.vue'
import logRecord from './log-record/index.vue'
export default {
  components: {
    workComplete,
    logRecord
  },
  data () {
    return {
      activeName: 'workComplete'
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.statistical-work {
  display: flex;
  flex-direction: column;
  height: 100%;
  // min-width: 1000px;

  // /deep/ .el-tabs__nav-wrap {
  //   padding: 0 !important;
  // }

  // /deep/ .el-tabs__nav-scroll {
  //   .el-tabs__item {
  //     font-size: 16px;
  //     height: 60px;
  //     line-height: 60px;
  //     padding: 0 30px;
  //   }

  //   .el-tabs__item.is-active {
  //     color: #009cff !important;
  //   }

  //   .el-tabs__active-bar {
  //     background: #009cff !important;
  //   }
  // }

  // /deep/.el-date-editor--date {
  //   width: 140px;
  //   height: 32px;

  //   .el-input__inner {
  //     width: 140px;
  //     height: 32px;
  //   }
  // }

  /deep/ .el-input__prefix {
    .el-icon-date {
      line-height: 32px;
    }
  }

  /deep/ .el-input__icon {
    line-height: 32px;
  }

  .header {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      display: flex;

      .select-item {
        margin-right: 20px;
      }

      /deep/ .search-btn {
        padding: 0 14px !important;
        border-radius: 4px;

        .el-icon-search {
          font-size: 14px;
        }

        span {
          font-size: 13px;
          margin-left: 4px;
        }
      }

      /deep/ .reset-btn {
        span {
          font-size: 13px;
        }
      }
    }

    .new-add-btn {
      margin-right: 10px;
    }

    /deep/ .new-add-btn {
      padding: 0 8px !important;
    }

    /deep/ .export-btn {
      padding: 0 11px !important;
    }
  }
}
</style>
